import React from "react";
import bgDecorateLeftImg from "../../assets/images/the-mahamantra/svg/bg_decorate_left_vector.svg";
import bgDecorateRightImg from "../../assets/images/the-mahamantra/svg/bg_decorate_right_vector.svg";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import whiteTopImg from "../../assets/images/png/white_top_vector.png";
import theMahamantraGuruJi from "../../assets/images/the-mahamantra/webp/the_mahamantra.webp";
import CommonHeading from "../common/heading/CommonHeading";

const TheSupreme = () => {
  return (
    <>
      <div
        className="bg_orange py-5 px-3 position-relative z_index_1 the_mahamantra_section"
        id="mahamantra"
      >
        <img
          className="position-absolute d-none d-lg-block bg_decorate_left_vector_mahamantra"
          src={bgDecorateLeftImg}
          alt="bg_decorate_left_vector"
        />
        <img
          className="position-absolute d-none d-xl-block bg_decorate_right_vector"
          src={bgDecorateRightImg}
          alt="bg_decorate_right_vector"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra start-0"
          src={topFlowerImg}
          alt="no"
        />
        <img
          className="position-absolute bottom_flower_mahamantra  end-0 supreme_right_flower"
          src={bottomFlowerImg}
          alt="bottom_flower"
  />*/}
        {/* <img
          className="position-absolute top-0 end-0 w-100 mt_minus_2"
          src={whiteTopImg}
          alt="white_top_vector"
        /> */}
        <div className="container container_modified  px-lg-5 bg-white py-5 py-md-5 position-relative z_index_4">
          <CommonHeading
            heading="From The Mouth Of The Supreme"
            className="text-orange common_heading_text common_heading_text_brown mt-lg-3"
          />
          <h2 className="common_sub_heading text-center mb-3 mb-md-4 pb-md-3">
            Hari Om Tatsat Jai Guru Datta
          </h2>
          <div className="row justify-content-between px-lg-2 mx-xl-1 pt-xl-1">
            <div className="col-lg-7">
              <p className="common_para mb-2 mb-xl-3 lh_25">
                According to the core of the Vedas, the Bhagavad Gita, the Lord
                says that He takes birth again and again whenever the integral
                power of Dharma is being overtaken by the forces of disharmony
                and inhumanity. Thus, precisely at this time when good
                intentions are threatened by a significant rise in negativity,
                the Lord appears.
              </p>
              <p className="common_para mb-2 mb-xl-3 pe-xl-4 lh_25">
                This is what happened when Lord Datta appeared to the Great Sage 
                P.P. Punitachariji Maharaj also known as Bapushree at the foot of 
                the western face of Mount Girnar.
                The Lord Datta gave Bapushree the finest spiritual tool the world has
                known: the Divine Mantra - "Hari Om Tatsat Jai Guru Datta" - of
                incalculable value. In fact, Hari Om Tatsat Jai Guru Datta is a
                form of the Lord of Lords.
              </p>
              <p className="common_para the_mahamantra_third_para mb-0 mb-lg-unset lh_25">
                Such a supreme gift, from the Mouth of The Supreme, blesses
                whomsoever uses this unprecendented spiritual tool on every
                level of life. Its most obvious and experiential level of
                expression is the state of Meditation, so seemingly difficult to
                attain, especially in challenging times.
              </p>
            </div>
            <div className="col-lg-5 text-center text-lg-end px-xl-0 pt-4 mt-1 mt-md-3 mt-lg-0 pt-lg-0">
              <img
                className="w-100 the_mahamantra"
                src={theMahamantraGuruJi}
                alt="the_mahamantra"
              />
            </div>
            <div className="col-lg-11 pt-4 mt-1 mt-md-3 mt-lg-0 mt-xl-2">
              <p className="common_para mb-2 mb-xl-3 pt-lg-1 lh_25">
                Even those longing to meditate or already practicing any of the
                hundreds of types of meditation wonder, "How do I meditate?" or
                "Am I doing this meditation correctly?"
              </p>
              <p className="common_para mb-2 lh_25">
                Spontaneous Meditation, the gift that Bapushree won from the heart of
                Lord Datta, solves all such doubts, for in this brilliant,
                simple way given by Lord Datta there is no doing or effort
                required.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TheSupreme;
